var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailActivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 53C0 23.7288 23.7288 0 53 0C82.2711 0 106 23.7288 106 53C106 82.2712 82.2711 106 53 106C23.7288 106 0 82.2712 0 53ZM82.6696 37.6135L77.8534 32.7584C76.8561 31.7529 75.2323 31.7463 74.2268 32.7439L44.0185 62.7094L31.2404 49.8277C30.243 48.8222 28.6192 48.8155 27.6137 49.8129L22.7584 54.6291C21.7529 55.6265 21.7463 57.2502 22.7439 58.2559L42.1447 77.8138C43.1421 78.8193 44.7659 78.8259 45.7714 77.8283L82.6553 41.2404C83.6606 40.2428 83.667 38.619 82.6696 37.6135Z",
    fill: "#0e0333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailActivated);
export default __webpack_public_path__ + "static/media/email-activated.5b42187c328d1ba5331d8f985656a215.svg";
export { ForwardRef as ReactComponent };